<template>
  <b-row>
    <b-col style="posation: relative">
      <b-form-file
        ref="file"
        v-model="fileitem"
        v-on:change="handleFileUpload"
        placeholder="فایل را انتخاب کنید"
        drop-placeholder="فایل خود را اینجا بندازید"
        label="انتخاب"
        v-show="!loading"
        accept="image/* , .xlsx"
        :file-name-formatter="formatNames"
      ></b-form-file>

      <div class="text-center">
        <span
          class="uplfile spinner spinner-primary spinner-right"
          v-if="loading"
        ></span>
      </div>

      <b-form-invalid-feedback :state="validated">{{
        error
      }}</b-form-invalid-feedback>
    </b-col>
  </b-row>
</template>
<style>
.custom-file-label:after {
  content: "انتخاب فایل" !important;
}
.uplfile.spinner:before {
  width: 3rem;
  height: 3rem;
}
</style>
<script>
import httpHelper from "../helpers/httpHelper";
import { GET_CONTENT_EXCEL } from "@/core/services/store/getContentExcel.module";

export default {
  name: "FileUploader",
  data() {
    return {
      fileitem: null,
      file: "",
      loading: false,
      //error:'فرمت فایل ارسالی اشتباه است'
      error: "",
      validated: true,
    };
  },
  props: ["fileUploaded"],
  methods: {
    submitFile() {
      this.loading = true;
      httpHelper.setAuth();
      httpHelper.UploadFile(this.file).then((res) => {
        this.loading = false;
        this.fileitem=null;
        if (res.success) {
          this.validated = true;
          this.$emit("input", res.result);

          if (this.file.name.split(".")[1] === "xlsx") {
            this.$store.dispatch(GET_CONTENT_EXCEL, res.result).then((data) => {
              this.$emit("loadingTable", false);
            });
          }
          if (this.fileUploaded != null) {
            this.fileUploaded();
          }
        } else {
          this.error = res.error;
          this.validated = false;
        }
      });
    },
    handleFileUpload(event) {
      this.$emit("loadingTable", true);
      if (event?.target.files[0]?.name) {
        this.file = event?.target.files[0];
        this.submitFile();
        this.formatNames(event?.target.files[0]?.name);
      } else {
        this.loading = false;
      }
    },
    formatNames(files) {
      return files?.length === 1
        ? files[0]?.name
        : `${files?.length} files selected`;
    },
  },
};
</script>